<app-select-filter [parentFormGroup]="parentFormGroup"
                   noEntriesFoundLabel="Aucun élément trouvé"
                   [parentFormControlName]="parentFormControlName"
                   [elements]="lovValueElements"
                   [filterElementProcessor]="filterLovValues"
                   [loading]="service.loading$ | async"
                   [disabled]="disabled"
                   [deletable]="deletable"
                   [newItemModalOptions]="formattedNewItemModalOptions"
                   (_onSingleSelectionChange)="selectionChanged($event)">


  <ng-template template-content let-element='element'>
    <ng-container [ngTemplateOutlet]="template || defaultContentTpl" [ngTemplateOutletContext]="{element:element}"></ng-container>
  </ng-template>
</app-select-filter>

<ng-template #defaultContentTpl let-element='element'>
  {{element.label}}
</ng-template>
